import { computed } from "vue";
import { mapState, useStore } from "vuex";
import { useState } from "@/hook/useState";

export function useUserInfo(mapper) {
  const store = useStore();
  const storeStateFns = useState(["user"]);
  const userInfo = computed(() => storeStateFns.user.value);
  // 更新用户数据
  const refreshUserData = async () => {
    // 已经登录
    if (userInfo.value.token) {
      await store.dispatch("getAccountInfo");
    }
  };
  const isLogin = computed(() => !!userInfo.value.token);
  const role = computed(() => userInfo.value.info.role);
  const vipExpiration = computed(() => {
    return userInfo.value.info.vip_expiration;
  });
  return {
    isLogin: isLogin.value, // 是否登录‘
    role: role.value, // 角色
    vipExpiration: vipExpiration.value, // vip 有效期时间
    refreshUserData, // 更新用户数据
    verifyRole: (roles) => {
      // 验证角色
      if (roles && roles.length) {
        return roles.includes(userInfo.value.info.role);
      }
      return false;
    },
    getVipExpiration: () => {
      return userInfo.value.info?.vip_expiration;
    },
  };
}
